// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"AuthSetting--next-sr-only--zkC2xt3","widthFull":"AuthSetting--widthFull--1QTAf0b","footerButtonsContainer":"AuthSetting--footerButtonsContainer--25csfIo"};